import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { Award } from 'lucide-react';
export function AuthoritySection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="bg-slate-50 py-16 md:py-20 px-4" data-id="element-21">
      <div className="max-w-6xl mx-auto" data-id="element-22">
        <div className="grid md:grid-cols-2 gap-10 md:gap-12 items-center" data-id="element-23">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} animate={isInView ? {
          opacity: 1,
          x: 0
        } : {}} transition={{
          duration: 0.6
        }} className="relative" data-id="element-24">
            <img src="https://cdn.magicpatterns.com/uploads/jJmbxQmzZiyjXFfwh9Huyn/seguridad_dog.png" alt="Canine Behavior Specialist working with a Golden Retriever" className="w-full h-auto rounded-2xl shadow-2xl object-cover" data-id="element-25" />
            <div className="absolute -bottom-4 -right-4 bg-orange-500 text-white px-5 py-3 rounded-xl shadow-lg flex items-center gap-2" data-id="element-26">
              <Award className="w-5 h-5" data-id="element-27" />
              <span className="font-semibold text-sm" data-id="element-28">
                Certified Specialist
              </span>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} animate={isInView ? {
          opacity: 1,
          x: 0
        } : {}} transition={{
          duration: 0.6,
          delay: 0.15
        }} data-id="element-29">
            <p className="text-orange-500 font-semibold text-sm uppercase tracking-widest mb-3" data-id="element-30">
              Backed by Science
            </p>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-slate-900 mb-6 leading-tight" data-id="element-31">
              Developed by{' '}
              <span className="text-orange-500" data-id="element-32">Canine Psychology Experts</span>
            </h2>
            <p className="text-lg text-slate-700 leading-relaxed mb-6" data-id="element-33">
              Most trainers focus on{' '}
              <span className="font-semibold" data-id="element-34">punishing the symptoms</span>. We
              focus on the{' '}
              <span className="font-semibold text-slate-900" data-id="element-35">root cause</span>.
            </p>
            <p className="text-lg text-slate-700 leading-relaxed" data-id="element-36">
              This protocol was designed using{' '}
              <span className="font-semibold" data-id="element-37">
                scientifically-proven techniques
              </span>{' '}
              recommended by leading behaviorists in the USA to reprogram your
              dog's brain from{' '}
              <span className="bg-red-100 text-red-700 font-semibold px-2 py-0.5 rounded" data-id="element-38">
                "Panic Mode"
              </span>{' '}
              to{' '}
              <span className="bg-green-100 text-green-700 font-semibold px-2 py-0.5 rounded" data-id="element-39">
                "Calm State"
              </span>{' '}
              in just{' '}
              <span className="font-bold text-orange-500" data-id="element-40">
                15 minutes a day
              </span>
              .
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}